import Axios, { AxiosRequestConfig } from 'axios'

export interface AxiosConfig extends AxiosRequestConfig {
  accessKey?: string;
  hostUrl?: string;
  basePath?: string;
}

export type Host = keyof typeof hostAxiosInstances

const timeout = 10000
const hostAxiosInstances = {
  mockHost: Axios.create({
    baseURL: `${import.meta.env.VITE_MOCK_SERVER_URL}`,
  }),
}

function initAxios({
  ...restConfig
}: Omit<AxiosConfig, 'url' | 'baseURL'>) {
  for (const host in hostAxiosInstances) {
    const hostAxiosInstance = hostAxiosInstances[host as Host]
    Object.assign(hostAxiosInstance.defaults, {
      timeout: timeout,
      ...restConfig,
    })
  }
}

export const { mockHost } = hostAxiosInstances
export { hostAxiosInstances, initAxios }
